import api from './api';

const paymentPromiseService = {
  getAll: async () => (await api.get('/payment-promises')).data,
  getBySaleId: async (saleId) => (await api.get(`/payment-promises/sale/${saleId}`)).data,
  getDashboard: async () => (await api.get('/payment-promises/dashboard')).data,
  create: async (data) => (await api.post('/payment-promises', data)).data,
  updateStatus: async (id, status) => (await api.patch(`/payment-promises/${id}/status`, { status })).data,
  delete: async (id) => (await api.delete(`/payment-promises/${id}`)).data,
};

export default paymentPromiseService;
